import { mapStyles2 } from "./mapStyles";

export const containerStyle = { width: "100%", height: "100vh" };
export const center = { lat: 33.5138, lng: 36.2765 };

export const options: google.maps.MapOptions = {
  styles: mapStyles2,
  disableDefaultUI: true,
  zoomControl: true,
};
export interface IMarkerType {
  id: string;
  location: google.maps.LatLngLiteral;
  name: string;
  phone_number: string;
  website: string;
}
